import { render, staticRenderFns } from "./MetricGoalModal.vue?vue&type=template&id=b5781c08"
import script from "./MetricGoalModal.vue?vue&type=script&lang=js"
export * from "./MetricGoalModal.vue?vue&type=script&lang=js"
import style0 from "./MetricGoalModal.vue?vue&type=style&index=0&id=b5781c08&prod&lang=scss"
import style1 from "./MetricGoalModal.vue?vue&type=style&index=1&id=b5781c08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports